import { render, staticRenderFns } from "./DepartmentHistoryForceEdit.vue?vue&type=template&id=f84fa83c&scoped=true&lang=pug&"
import script from "./scripts/DepartmentHistoryForceEdit.js?vue&type=script&lang=js&"
export * from "./scripts/DepartmentHistoryForceEdit.js?vue&type=script&lang=js&"
import style0 from "./DepartmentHistoryForceEdit.vue?vue&type=style&index=0&id=f84fa83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84fa83c",
  null
  
)

export default component.exports